import React from "react";
import "./assets/scss/themes.scss";
import "./i18n"; // i18n 架構預埋(key-based;第一階段繁中)
import Routing from "./routes/index";

import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import config from "./config";
import setupMock from "./mock";
import registerNotImplementedGuards from "./mock/notImplemented";
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { RbacProvider, FeedbackProvider } from "./components/DCKeeper";
import { QueryProvider } from "./query/QueryProvider";
import { useSessionStore } from "./stores/sessionStore";
import { MOCK_JWT_TOKEN } from "./constants/auth";
import AppErrorBoundary from "./components/AppErrorBoundary";

// 後端 API 未到位時啟用 mock 層（含假登入 + DC Keeper 資源）；
// Swagger 到位後在 .env 設 REACT_APP_USE_MOCK=false 即改走真後端。
if (config.USE_MOCK) {
  setupMock();
} else {
  // 正式模式:未遷移模組的舊端點不出網、回 501 誠實說明「尚未串接」——
  // 不對真後端亂槍打鳥(CORS 噪音),也不讓畫面謊報「網路連線異常」
  const realModeMock = new MockAdapter(axios, { onNoMatch: "passthrough" });
  fakeBackend(realModeMock); // 模板假登入暫留(不影響 /api-backend/*)
  registerNotImplementedGuards(realModeMock);
}

// —— session 啟動 ——
// 還原 localStorage 的登入;mock 模式無登入時建立 dev session(Overseer)讓開發/e2e 可用。
// 正式登入 API 到位後,改由登入頁呼叫 useSessionStore.login(user, token) 即可。
useSessionStore.getState().hydrate();
// hybrid 模式不建 dev session:登入/身分組裝走真後端,mock-jwt-token 打過去必 401
if (config.USE_MOCK && !config.BACKEND_PASSTHROUGH && !useSessionStore.getState().isAuthenticated) {
  // dev token:mock 的 /api-backend/* 端點與真後端一致要求 Bearer header
  useSessionStore.getState().login({
    id: 1, name: "林承翰", employeeId: "DEV-001", role: "Overseer",
  }, MOCK_JWT_TOKEN);
  // 與正式登入相同的身分組裝流程(非同步補齊,不阻擋啟動)
  useSessionStore.getState().assembleIdentity();
}
// 401 → 登出並導回登入(防迴圈)
if (typeof window !== "undefined") {
  window.addEventListener("auth:unauthorized", () => {
    useSessionStore.getState().logout();
    if (window.location.pathname !== "/auth-login") window.location.assign("/auth-login");
  });
}

function App() {
  return (
    <AppErrorBoundary>
      <QueryProvider>
        <RbacProvider>
          <FeedbackProvider>
            <Routing />
          </FeedbackProvider>
        </RbacProvider>
      </QueryProvider>
    </AppErrorBoundary>
  );
}

export default App;
